import { computed } from 'vue'
import cfg from '@root/config'
import { useBillingStore } from '@/store/stores/billing'
import { useProject } from '@/hooks/useProject'
import { useUser } from '@/hooks/useUser'

// Тарифы, доступные клиенту на пробном периоде: «Умный бот» (tariff2) и tariff3.
export const TRIAL_ALLOWED_TARIFF_IDS = ['tariff2', 'tariff3']
// Тариф, выбранный по умолчанию на пробном периоде — «Умный бот».
export const TRIAL_DEFAULT_TARIFF_ID = 'tariff2'
// На пробном периоде помесячная оплата скрыта, минимальный и дефолтный период — 3 месяца.
export const TRIAL_DEFAULT_PERIOD = '3'

// Сопоставляем тариф по базовому id, чтобы промо-варианты (baseTariffId) тоже проходили фильтр.
export function isTrialAllowedTariff(tariff: { id: string; baseTariffId?: string | null }): boolean {
    return TRIAL_ALLOWED_TARIFF_IDS.includes(tariff.baseTariffId ?? tariff.id)
}

/**
 * Ограничения витрины тарифов для клиента на пробном тарифе (is_trial):
 *  - в списке тарифов доступны только «Умный бот» (tariff2) и tariff3;
 *  - период оплаты «на месяц» скрыт, дефолт — 3 месяца.
 * Для суперпользователя (adminsWhitelist) ограничения не действуют — витрина отображается как обычно.
 */
export function useTariffTrialRestrictions() {
    const billingStore = useBillingStore()
    const { project } = useProject()
    const { user } = useUser()

    const isSuperUser = computed(
        () => Array.isArray(cfg.adminsWhitelist) && cfg.adminsWhitelist.includes(user.value?.sub)
    )
    const currentTariff = computed(() => billingStore.getCurrentTariff(project.value?.id))
    const isTrial = computed(() => Boolean(currentTariff.value?.isTrial))
    const isTrialRestricted = computed(() => isTrial.value && !isSuperUser.value)

    return { isTrialRestricted, isSuperUser, isTrial }
}
